import React from "react";
import { Switch } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleSwitchProps extends React.ComponentProps<typeof Switch> {
  useEditorTheme?: boolean;
}

const TrebbleSwitch = ({ useEditorTheme, ...restProps }: TrebbleSwitchProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Switch {...restProps} />
    </TrebbleConfigProvider>
  );
};

export default TrebbleSwitch; 